/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderCreateCargo } from './order_create_cargo'
import type { OrderCreateCargoInfo } from './order_create_cargo_info'
import type { OrderCreateCargoTotal } from './order_create_cargo_total'
import type { OrderCreateCustomer } from './order_create_customer'
import type { OrderCreateDeparture } from './order_create_departure'
import type { OrderCreateDestination } from './order_create_destination'
import type { OrderCreateOperation } from './order_create_operation'
import type { OrderCreateOperationItem } from './order_create_operation_item'
import type { OrderCreatePartner } from './order_create_partner'
import type { OrderCreatePayer } from './order_create_payer'
import type { OrderCreatePoint } from './order_create_point'
/**
 * Запрос на создание заявки
 */
export type OrderCreateRequest = {
  /**
   * Параметры пункта отправления
   */
  departure?: OrderCreateDeparture
  /**
   * Параметры пункта назначения
   */
  destination?: OrderCreateDestination
  /**
   * Заказчик
   */
  customer: OrderCreateCustomer
  /**
   * Плательщик
   */
  payer: OrderCreatePayer
  /**
   * Грузоотправитель
   * @deprecated
   */
  //  departurePartner?: OrderCreatePartner;
  /**
   * Грузополучатель
   * @deprecated
   */
  //  destinationPartner?: OrderCreatePartner;
  /**
   * Плановая дата передачи груза
   * @deprecated
   */
  //  departureDate?: string;
  /**
   * Пункт отправления
   * @deprecated
   */
  //  departurePoint?: OrderCreatePoint;
  /**
   * Пункт назначения
   * @deprecated
   */
  //  destinationPoint?: OrderCreatePoint;
  /**
   * Груз
   */
  cargoInfo?: OrderCreateCargoInfo
  /**
   * Способ указания информации о грузе
   */
  cargoType?: OrderCreateRequest.cargoType
  /**
   * Грузоместа
   */
  cargo?: Array<OrderCreateCargo>
  /**
   * Информация о грузе в виде общего веса и объема
   */
  cargoTotal?: OrderCreateCargoTotal
  /**
   * Дополнительные услуги
   */
  operation?: Array<OrderCreateOperation>
  /**
   * Дополнительные услуги без привязки к терминалам
   */
  operations?: Array<OrderCreateOperationItem>
  /**
   * Согласен с офертой
   */
  isAgreeOffer: boolean
  /**
   * Комментарий к заявке
   */
  comment?: string
}
export namespace OrderCreateRequest {
  /**
   * Способ указания информации о грузе
   */
  export enum cargoType {
    SEPARATE = 'separate',
    TOTAL = 'total'
  }
}
